import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import {
  Table as BaseTable,
  Th as BaseTh,
  Td as BaseTd,
} from 'apps/payment/styles';

export const Table = styled(BaseTable)`
  margin: ${props => (props.first ? '30px 0px' : '20px 0px')};
  ${media.xs`
    display: block;
    overflow-x: auto;
  `};
`;

export const Th = styled(BaseTh)`
  padding: 20px;
  > p {
    font-size: 1em;
  }
`;

export const Td = styled(BaseTd)`
  font-size: 0.875em;
  padding: 15px;
`;
